import isUserRolGuard from "@/guards/isUserRolGuard";

export default [
  {
    path: "sitio",
    name: "sitio",
    beforeEnter: isUserRolGuard,
    component: () => import("@/pages/parametros/Sitio/sitio.vue"),
  },
];
